<template>
  <label :class="{ disabled }">
    <Checkbox :binary :disabled :value v-model="modelValue" :class="checkboxClass"/>
    <slot></slot>
  </label>
</template>

<script setup>
import { computed } from "vue";
import Checkbox from "primevue/checkbox";

let props = defineProps({
  faded: Boolean,
  disabled: Boolean,
  binary: { type: Boolean, default: true },
  value: {},
  modelValue: {}
});

let modelValue = defineModel("modelValue");

let checkboxClass = computed(() => {
  return {
    faded: props.faded,
    selected: modelValue.value
  };
});
</script>

<style scoped>
label {
  padding: 2px;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 15px;
}
label.disabled {
  color: var(--gray-500);
}
:deep(.p-checkbox-box) {
  scale: 1.2;
}
:deep(.faded) .p-checkbox-box {
  background: var(--gray-100);
  border-color: var(--gray-200);
}
:deep(.faded.selected) .p-checkbox-box {
  background: var(--gray-300);
  border-color: var(--gray-400);
}
</style>